<template>
  <div class="demo">
    <div class="hero">
      <div class="container">
        <h3>Case study van Zinzia</h3>
        <h1>
          Tevreden cliënten en productievere behandelaars bij zorggroep Zinzia
          dankzij Roosterplatform
        </h1>
        <p>
          "Sinds wij met Roosterplatform werken, is de cliënttevredenheid
          gestegen en zijn wij als behandelaars productiever," stelt Rob van
          Roest, fysiotherapeut en operationeel projectleider bij zorggroep
          Zinzia. Zinzia biedt complexe en intensieve verpleeghuis-,
          revalidatie- en hospicezorg in Zuid-Gelderland en werkt sinds 2021 aan
          met Roosterplatform aan procesverbetering.
        </p>
        <img
          src="../assets/img/clients/hero-zinzia.png"
          alt="Roosterplatform webinar"
        >
        <div>
          <small
            class="opacity"
          >Plaatje afkomstig van de website van Zinzia</small>
        </div>
      </div>
    </div>

    <div class="section grey-light extra-padding-bottom">
      <div class="container">
        <div class="section-title">
          <span>Uitdaging</span>
          <h3>Cultuurverandering en oplossen 'verkeerde bed'-probleem</h3>
        </div>
        <p>
          "De procesverbetering, of eigenlijk een cultuurverandering, was hard
          nodig," legt Rob uit, "want we werkten nog op basis van veel oude en
          achterhaalde gedachten. En verder spelen wij een belangrijke rol in
          het 'verkeerde bed'-probleem waarbij patiënten in het ziekenhuis
          uitbehandeld zijn maar nog niet naar huis kunnen en daardoor onnodig
          een ziekenhuisbed bezet houden. Als wij deze patiënten bij ons het
          juiste bed bieden en intensief behandelen zodat ze snel weer naar huis
          kunnen, verbetert dat de hele doorstroom in de zorg en bespaart dat
          veel kosten."
        </p>

        <div class="section-title">
          <span>Gevolgen</span>
          <h3>
            Gebrekkige en verouderde werkwijze, en geen behandelagenda voor
            cliënten
          </h3>
        </div>
        <p>
          Door een audit van zorgverzekeraars ontdekte Zinzia dat
          behandelprocessen niet goed liepen en dat het lastig was om aan de
          gestelde kwaliteitseisen te voldoen. "Ons gebrek aan inzicht en de
          verouderde werkwijze kwam toen duidelijk aan het licht," vertelt Rob,
          "En dan ging het om kernzaken als: Wat doen behandelaren nou precies
          op een dag? Hoe wordt een dag ingedeeld? En is dat wel efficiënt?"
        </p>
        <p>
          Daarnaast hadden cliënten geen inzicht in de behandelagenda: "De fysio
          liep gewoon binnen en daarna kwam de ergotherapeut ook nog langs
          waardoor het voor familie onduidelijk was wanneer ze op bezoek konden
          komen."
        </p>
        <div class="section-title">
          <span>Oplossing</span>
          <h3>Procesverbetering met Roosterplatform</h3>
        </div>
        <p>
          Rob nam na de audit de rol van operationeel projectleider voor de
          verbeteringen op zich: "Door de audit was het gewoon duidelijk dat we
          moesten verbeteren. En begin 2021 hebben we alles op een rij gezet met
          graven als: Hoe kunnen we onze behandelprocessen verbeteren en waar
          kunnen we winst halen? En hoe benutten we de DBC's beter?"
        </p>
        <p>
          Voor procesverbetering had Zinzia inzicht nodig in de zorgvraag en de
          capaciteit van de behandelaars. Om daarna met de zorgvraag als
          uitgangspunt te bepalen wat men nodig heeft aan behandelaars, maar ook
          wat de behandelaars aankunnen. Hierdoor ziet men meteen of een
          behandeling nog past of dat men juist te krap of te ruim zit. "Voor de
          verbeteringen hadden we naast een andere werkwijze en goede afspraken
          ook de hulp van automatisering nodig om een optimale behandelplanning
          te maken," legt Rob uit, "en die hulp vonden wij in Roosterplatform."
        </p>
        <div class="section-title">
          <span>Resultaat</span>
          <h3>Tevreden cliënten en meer efficiëntie en werkplezier</h3>
        </div>
        <p>
          Met de geautomatiseerde planning van Roosterplatform kan Zinzia nu
          intensiever behandelen waardoor cliënten sneller naar huis kunnen en
          Zinzia structureel het 'verkeerde-bed'-probleem helpt oplossen.
          Daarnaast zijn de behandelaars productiever: "Ons behandelproces is nu
          veel efficiënter. En ons werk is ook leuker geworden omdat we door de
          geautomatiseerde planning flexibeler zijn en nu een dag vrij kunnen
          nemen zonder zorgen over de cliënt en de behandeling."
        </p>
        <p>
          Verder werken de behandelaars beter samen door het inzicht dat
          Roosterplatform geeft: "Vroeger waren we vooral eilandjes, maar nu
          werken we echt samen aan een behandeling. Er is veel meer eenheid en
          structuur op de afdeling."
        </p>
        <p>
          En dat ziet Zinzia direct terug in tevreden cliënten zoals bleek uit
          klantenonderzoek: "Cliënten weten nu precies waar ze aan toe zijn en
          zitten al klaar als wij komen. Verder weten ze wanneer ze kunnen
          rusten of wanneer familie en vrienden op bezoek kunnen komen."
        </p>
        <p>
          Tenslotte vat Rob de voordelen van Roosterplatform voor Zinzia nog
          even samen:
        </p>
        <ul>
          <li>
            Intensiever behandelen en oplossen van het 'verkeerde-bed'-probleem.
          </li>
          <li>
            Tevreden cliënten die zo snel mogelijk weer zelfstandig thuis zijn.
          </li>
          <li>Productiever werken en efficiënte behandelprocessen.</li>
          <li>Meer werkplezier bij de behandelaars.</li>
          Beter benutten van DBC's.
        </ul>
        <p>
          Inmiddels krijgt Zinzia een fraaie 7,5 op ZorgkaartNederland: "En dat
          hebben we in amper een jaar bereikt. Maar natuurlijk zitten we nu niet
          stil en blijven we zoeken naar verbeteringen."
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Zinzia",

  mounted() {},
  methods: {},
  metaInfo() {
    return {
      title: "Roosterplatform - Zinzia",
    };
  },
};
</script>

<style scoped lang="scss">
@import "../assets/css/colors.scss";
@import "../assets/css/variables.scss";
.hero {
  padding: 100px 0;
  p {
    font-size: $big;
  }
  h3 {
    opacity: 0.3;
    font-weight: 700;
  }
  position: relative;
  z-index: 1;
}
.zoho-form {
  background: $grey-light;
  border-radius: $border-radius;
}
img {
  border-radius: $border-radius;
}
p + .section-title {
  margin-top: 50px;
}
@media (max-width: 767px) {
  .hero {
    padding-top: $header-height-small;
  }
}
</style>
